// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'align-center';

export const Component = () => (
  <path d='M7.262 3.43c-.326 0-.466-.14-.466-.465s.14-.465.466-.465h10.476c.326 0 .512.14.512.465 0 .326-.186.465-.512.465H7.262Zm-4.75 4.79h20.022c.326 0 .466-.139.466-.464 0-.326-.14-.512-.466-.512H2.512c-.326 0-.512.186-.512.512 0 .325.186.465.512.465Zm15.226 3.815H7.262c-.326 0-.466.14-.466.465s.14.465.466.465h10.476c.326 0 .512-.14.512-.465s-.186-.465-.512-.465Zm4.796 4.743H2.512c-.326 0-.512.14-.512.466 0 .325.186.51.512.51h20.022c.326 0 .466-.185.466-.51 0-.326-.14-.466-.466-.466Zm-4.796 4.792H7.262c-.326 0-.466.14-.466.465s.14.465.466.465h10.476c.326 0 .512-.14.512-.465 0-.326-.186-.465-.512-.465Z' />
);

export const viewBox = '0 0 25 25';
